// src/App.js
import Header from "./components/layout/Header";
import UnderHeader from "./components/layout/UnderHeader";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from './pages/Home/Home';
import ProductsScreen from './screens/ProductsScreen';
import Cart from './pages/Cart/Cart';
import CustomerAccount from './pages/CustomerAccount/pages/CustomerAccount';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import Order from './pages/Order/Order';
import PayResultScreen from "./screens/PayResultScreen";
import PrivateComponent from "./components/PrivateComponent";
import AdminPanel from './pages/Admin/Admin';
import EditProductPage from './pages/Admin/Components/EditProductPage';
import ProductPage from './pages/Product';
import DiscountPage from './pages/Discount/DiscountPage';
import FaqPage from './pages/Faq/FaqPage';
import About from './pages/About/About';
import Rule from './pages/Rule/Rule';   // ✅ صفحه قوانین

// ✅ صفحات احراز هویت OTP
import PhoneEntry from "./pages/Auth/PhoneEntry";
import OTPVerification from "./pages/Auth/OTPVerification";
import SetUsername from "./pages/Auth/SetUsername";

// ✅ صفحه تماس با ما
import Contact from './pages/Contact/Contact';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminRoute = ({ component: Component, ...rest }) => {
  const { userInfo } = useSelector(state => state.auth);
  if (!userInfo?.access) {
    return <Navigate to="/phone" />;
  }
  if (!userInfo?.isAdmin) {
    return <Navigate to="/" />;
  }
  return <Component {...rest} />;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <UnderHeader />
      <main>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<ProductsScreen />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={<Cart />} />

            {/* مسیرهای احراز هویت OTP */}
            <Route path="/phone" element={<PhoneEntry />} />
            <Route path="/verify-otp" element={<OTPVerification />} />
            <Route path="/set-username" element={<SetUsername />} />

            {/* مسیرهای محافظت‌شده */}
            <Route path="/profile" element={<PrivateComponent component={CustomerAccount} />} />
            <Route path="/shipping" element={<PrivateComponent component={ShippingScreen} />} />
            <Route path="/payment" element={<PrivateComponent component={PaymentScreen} />} />
            <Route path="/placeorder" element={<PrivateComponent component={PlaceOrderScreen} />} />
            <Route path="/order/:orderId" element={<PrivateComponent component={Order} />} />
            <Route path="/pay-result/:token" element={<PrivateComponent component={PayResultScreen} />} />

            <Route path="/admin/*" element={<AdminRoute component={AdminPanel} />} />
            <Route path="/admin/product/edit/:id" element={<AdminRoute component={EditProductPage} />} />

            <Route path="/discount" element={<DiscountPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* ✅ صفحه قوانین و مقررات (برای اینماد) */}
            <Route path="/rules" element={<Rule />} />
          </Routes>
        </ErrorBoundary>
      </main>
      <Footer />
    </Router>
  );
}

export default App;